import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EventCode from './EventCode';
import {
  getEventCode,
  getUserProfileWidget,
  getCurrentTimezone,
  getUserOrgModelCategoryType
} from '../../selectors/index';
import {
  describeEventCodeThunk,
  deleteEventCodeThunk,
  setEventCodeChangeThunk,
  saveEventCodeThunk,
  eventCodeCleanUpThunk
} from '../../actions/eventCode';

const mapStateToProps = state => {
  return {
    eventCodeManager: getEventCode(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      describeEventCode: (eventCodeId, modelCategoryId) => describeEventCodeThunk(eventCodeId, 'EVENTCODEUPDATE', modelCategoryId),
      deleteEventCode: (eventCodeId, modelCategoryId) => deleteEventCodeThunk(eventCodeId, 'EVENTCODEDELETE', modelCategoryId),
      setEventCodeChange: eventCode => setEventCodeChangeThunk(eventCode),
      saveEventCode: (eventCode, widgetCode) => saveEventCodeThunk(eventCode, widgetCode),
      eventCodeCleanUp: eventCode => eventCodeCleanUpThunk(eventCode)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EventCode);
